





































































import Component from "vue-class-component";
import Vue from "vue";
import { Prop, Watch } from "vue-property-decorator";
import CheckoutReviewViewModel from "@/chipply/view-model/CheckoutReviewViewModel";
import CAddressEditor from "@/components/CAddressEditor.vue";

@Component({
    components: {
        CAddressEditor,
    },
})
export default class CheckoutPickupDeliveryForm extends Vue {
    public name = "CheckoutPickupDeliveryForm";

    @Prop({ type: Object })
    public stepStatus!: { advancing: false; isLoading: false; sameAddress: false; shipDirect: false };

    @Prop({ type: Object })
    public vm!: CheckoutReviewViewModel;

    public shipFormValid = false;

    public $refs!: { form: any };

    public resetValidation() {
        this.$refs.form?.resetValidation();
    }

    public validate() {
        return this.$refs.form?.validate();
    }

    public canValidate() {
        return this.$refs.form;
    }
}
